<script>
    import FaIcon from 'svelte-awesome';
    import { exclamationTriangle } from 'svelte-awesome/icons';

    import { createEventDispatcher } from 'svelte';
    const dispatch = createEventDispatcher();

    export let settled;
    export let closed;
    export let isLive;
</script>

{#if settled}
    <div class="project-notice settled">
        This Partipie has been settled
    </div>
{:else if closed}
    <div class="project-notice closed">
        This Partipie has been closed and is archived
    </div>
{:else if !isLive}
    <div class="project-notice draft">
        <FaIcon data={exclamationTriangle}/>
        This Partipie is still in draft.
        Configure the
        <a href="#" on:click={() => dispatch("openProjectFields")}>partipie agreements</a>
        to go live.
    </div>
{/if}

<style>
    .project-notice {
        padding: 10px;
        text-align: center;
        position: relative;
        opacity: 0.9;
        font-weight: bold;
    }

    .project-notice.settled {
        background: green;
        color: white;
    }

    .project-notice.draft {
        background: yellow;
        color: #6d5d1f;
    }

    .project-settings-button {
        margin-left: 10px;
    }

    .project-notice.closed {
        background: yellow;
        color: #333;
    }
</style>